import axios from 'axios';

// Aktiiviset nimikkeet haetaan kerran per sivulataus (ItemCombobox); tyhjennetään nimikettä muokattaessa
// ja varastoon kirjattaessa, koska kirjauksen à-hinta päivittyy nimikkeen hinnaksi.
// Tenantin vaihto lataa sivun uudelleen, joten välimuisti ei vuoda tenantilta toiselle.
let cachedItems = null;

export default {
  async getItems() {
    return await axios({
      url: '/api/tenant/item/',
    }).then(r => r.data);
  },
  getItemsCached() {
    if (!cachedItems) {
      cachedItems = this.getItems().catch(error => {
        cachedItems = null;
        throw error;
      });
    }
    return cachedItems;
  },
  clearCache() {
    cachedItems = null;
  },
  async updateItem(id, /* Item */ data) {
    cachedItems = null;
    return await axios({
      url: '/api/tenant/item/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },
  async removeItem(id, /* Item */ data) {
    cachedItems = null;
    return await axios({
      url: '/api/tenant/item/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },
  async createItem(data) {
    cachedItems = null;
    return await axios({
      url: '/api/tenant/item/',
      method: 'post',
      data,
    }).then(r => r.data);
  },
  async getItem(id) {
    return await axios({
      url: '/api/tenant/item/' + id,
    }).then(r => r.data);
  },
  // Aktiiviset nimikkeet nimiketyyppien id:iden mukaan (helpers/itemTypes.js); tyhjä lista = ei yhtään.
  async getItemsByTypes(/*Array<Number>*/ typeIds) {
    return await axios({
      method: 'post',
      url: '/api/tenant/item/types',
      data: { typeIds },
    }).then(r => r.data);
  },
  async exportItemsExcel() {
    const response = await axios({
      url: '/api/tenant/item/export/excel',
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'nimikkeet.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
